import React, { useState } from "react";
import {
  Button, Tooltip,
} from "antd";
// import { FormContext } from "./MicroPendingTableRow";
import { EyeInvisibleOutlined } from "@ant-design/icons";
import MicroPendingHistoryModal from "./MicroPendingHistoryModal";
import "./MicroPendingTableCell.css";

const MicroPendingTableCell = ({
  title,
  children,
  dataIndex,
  record,
  handleSubmit,
  handleRemoveMapping,
  updateSample,
  checkRowDisabled,
  checkDisableInteraction,
  submittingKey,
  removingKey,
  isPending,
  user,
  ...antdProps
}) => {
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  // const form = useContext(FormContext);

  // const save = async () => {
  //   try {
  //     const values = await form.validateFields();
  //     handleSubmit(record, { ...values });
  //   } catch (errInfo) {
  //     // console.log("Save failed:", errInfo);
  //   }
  // };

  let childNode = children;

  /** Petrifilm: hide petrifilm value if mapping is false */
  if (dataIndex === "petrifilm") {
    childNode = <span>{record.mapping || isPending ? record.petrifilm : ""}</span>;
  }

  /** Counts and DF: allow user to input value (df only if pending and df is empty) */
  if (dataIndex === "counts" || dataIndex === "df") {
    childNode = <span>{record[dataIndex] || ""}</span>;
  }

  if (dataIndex === "genista_id") {
    childNode = (
      <div className="MicroPendingTableCell__GenistaContainer">
        {record.sample_hidden === 1 && user && user.permissionMap.view_hidden_sample_icon_automation && <EyeInvisibleOutlined />}
        <span>{record[dataIndex]}</span>
      </div>
    );
  }

  if (dataIndex === "wo_id") {
    childNode = (
      <div className="MicroPendingTableCell__GenistaContainer">
        {record.is_deleted === 2 && user && user.permissionMap.view_hidden_workorder_icon_automation && <EyeInvisibleOutlined />}
        <span>{record[dataIndex]}</span>
      </div>
    );
  }

  /** Action: show submit button */
  if (dataIndex === "action") {
    // childNode = (
    //   <div className="MicroPendingTable__ActionCell">
    //     {checkRowDisabled(record) ? (
    //       <span>
    //         {record.status === "Ready" ? (
    //           <Button
    //             onClick={() => updateSample(record.key, { ...record, edit: true })}
    //             disabled={checkDisableInteraction()}
    //           >
    //             Edit
    //           </Button>
    //         ) : "Submitted" }
    //       </span>
    //     )
    //       : (
    //         <Button
    //           onClick={save}
    //           loading={submittingKey === record.key}
    //           disabled={checkDisableInteraction()}
    //         >
    //           {record.recheck ? "Verify" : "Submit"}
    //         </Button>
    //       )}
    //   </div>
    // );

    childNode = (
      <div className="MicroPendingTable__HistoryCell">
        <Button onClick={() => setOpenHistoryModal(true)}>History</Button>
        {openHistoryModal && (
          <MicroPendingHistoryModal
            parentData={record}
            onCancel={() => setOpenHistoryModal(false)}
          />
        )}
      </div>
    );
  }

  const tooltipTitle = () => {
    /** Case for mapping is true */
    if (record.petrifilm !== "" && record.petrifilm.length > 0) {
      return (
        <span>
          This will remove the petrifilm mapping.
        </span>
      );
    }
    /** Case for mapping is false */
    return (<span>Current analysis does not have a mapping.</span>);
  };

  /** Mapping: show the Remove button */
  if (dataIndex === "mapping") {
    childNode = (
      <div className="ScannerTable__ActionCell">
        <Tooltip
          title={tooltipTitle()}
        >
          <Button
            onClick={() => handleRemoveMapping(record)}
            loading={removingKey === record.key}
            disabled={record.petrifilm === "" || removingKey > -1}
          >
            Remove
          </Button>
        </Tooltip>
      </div>
    );
  }

  /** All other columns: show string value */
  return <td {...antdProps}>{childNode}</td>; // eslint-disable-line react/jsx-props-no-spreading
};

export default MicroPendingTableCell;
